module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_y-11dac9a74d98b2422f414ae17f7fe51c.png";